import React from 'react';
import Month from './Month';
import Goal from './Goal';

const CalendarHalf = ({ datesArray, rotate }) => {
  return ( 
    <div className={`calendar-half ${rotate}`}>
      <Goal date={datesArray[0]} watermark="" />
      <Goal date={datesArray[1]} watermark="Carpe Diem Calendar" />
      <Goal date={datesArray[2]} watermark="" />
      <Month date={datesArray[0]} />
      <Month date={datesArray[1]} />
      <Month date={datesArray[2]} />
    </div>
   );
}

export default CalendarHalf;